import { apiWithoutInterceptor, apiWithInterceptor } from './';

export const login = (email, password) => apiWithoutInterceptor.post(`/auth`, { email, password })
export const logout = () => apiWithInterceptor.post(`/logout`)